<template>
    <div class="newLogin">
			<!--<img class="bg" src="../../assets/img/loginBg.png" alt="">-->
		<!--	<div id="box2">
				<h2>你好！</h2>
				<p>欢迎来到若水出行平台</p>
				&lt;!&ndash;<pwd-login :loginMethod.sync="loginMethod"></pwd-login>&ndash;&gt;
			</div>-->
      <div  class="login-top">
        <div class="top-logo">
          <el-row>
            <el-col :span="8">&nbsp;</el-col>
            <el-col :span="8">
              <el-row>
                <el-col style="margin-top: 10px" :span="24">
                 <div class="animated fadeInRight welcome" style="text-align: center;font-width:bold;color:#fff;">欢迎登录若水出行平台</div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">&nbsp;</el-col>
          </el-row>
        </div>
      </div>
      <div class="login-main animated fadeInRight" >
        <el-row>
          <el-col :span="8">&nbsp;</el-col>
          <el-col :span="8">
            <div class="login-box">
              <div class="login-left">
               <!-- <div v-if="loginMethod =='code'" class="animated fadeIn" key="box1">
                  <code-login :loginMethod.sync="loginMethod" ></code-login>
                </div>
                <div v-else key="box2" class="animated fadeIn">-->
                  <pwd-login :loginMethod.sync="loginMethod"></pwd-login>
                <!--</div>-->
              </div>
            </div>
          </el-col>
          <el-col :span="8">&nbsp;</el-col>
        </el-row>
      </div>
		</div>
</template>

<script>
	import {setRem} from '@/util/commen.js'
  import pwdLogin from './pwdlogin'

  export default {
    name: 'codelogin',
    components: {pwdLogin},
    data() {
      return {
        loginMethod: 'code'
      };
    },
    created() {
			setRem();
    },
    mounted() {},
    computed: {
    },
    props: [],
    methods: {
    },
  };
</script>
<!--<style scoped>
  body{
    background: #ffffff!important;
  }
  .newLogin{
    background: #ffffff;
    height: 100%;
  }
  .newLogin >>> .el-input .el-input__inner{
    color:#606266!important;
  }
	.bg{
		position: fixed;
		right: 0;
		bottom: 0;
		height: 100%;
		margin: 0;
	}
	.logo{
		position: fixed;
		width: 247px;
		left:44px;
		top:32px;
	}
	#box2{
		position: fixed;
		left:1.20rem;
		top: 2rem;
	}
	#box2 h2{
		font-size:.54rem;
		font-weight:500;
		color:rgba(14,18,26,1);
		margin-bottom: .16rem;
	}
	#box2 p{
		font-size:.26rem;
		font-weight:400;
		color:rgba(14,18,26,1);
		}

</style>-->
 <style lang="scss">
  .newLogin{
    height: 100%;
    background: #3a4765;
    .login-top{
      height: 40%;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      .top-logo{
        color: #666;
        font-size: 20px;

      }
    }
    .login-box{
      display: flex;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 50px 40px;
      box-sizing: border-box;
      margin-top: -18%;
      background-color: #fff;
      z-index: 5;
      .login-left{
        flex: 1;
        box-sizing: border-box;
        .el-input__inner{
          background-color: #fff !important;
          height: 40px;
          line-height: 40px;
        }
        .el-input-group__append{
          background-color: #008cc9;
          color: #fff;
        }
        .change-method{
          color: #008cc9;
          text-align: right;
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 40px;
          cursor: pointer;
        }
        .el-button--primary{
          width: 100%;
          height: 50px;
          font-size: 16px;
          background-color: #008cc9;
        }
        .agreement{
          color: #008cc9;
          font-size: 13px;
          text-align: center;
        }
        .fade-enter, .fade-leave-to {
          opacity: 0
        }
        .fade-leave, .fade-enter-to {
          opacity: 1
        }
        .fade-enter-active, .fade-leave-active {
          transition: all .2s
        }
      }
      .login-right{
        flex: 1;
        padding-left: 50px;
        box-sizing: border-box;
        .title{
          color: #1ea0ff;
          font-size: 20px;
          letter-spacing: 3px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .attract{
          display: flex;
          align-items: center;
          color: #5E5E5E;
          margin-bottom: 25px;
          span{
            line-height: 25px;
          }
          .icon{
            font-size: 30px;
            margin-right: 20px;
          }
          .icon-zhilianganquan{
            color: #DE6266;
          }
          .icon-jingzhunpipei{
            color: #FB8524;
          }
          .icon-kuaijiejiancha{
            color: #1EB5FE;
          }
        }
        .connect{
          color: #c0c0c0;
          font-size: 13px;
          line-height: 30px;
          display: flex;
          align-items: center;
          margin-top: 30px;
          .phone-number{
            color: #fb7b11;
            font-size: 30px;
            font-weight: 600;
            margin-left: 10px;
          }
        }

      }
    }
  }

</style>
